<script lang="ts">
    import { slide } from 'svelte/transition';
    import { isMobile } from '$lib/stores';
    import AccordionIcon from '$lib/assets/icons/AccordionIcon.svelte';
    import { type Property, useLocaleContext, useLocaleISOContext, usePropertiesContext } from '$lib/context';
    import { buildFilterURL } from '$lib/util/searchUtil';
    import { t } from 'svelte-i18n';
    import { optional } from 'valibot';

    const lang = useLocaleContext();
    const isoCode = useLocaleISOContext();
    const properties = usePropertiesContext();

    export let dropdownActive: boolean;

    const categories = Object.values(properties).map((property: Property) => {
        if (!Object.values(property.translations).includes('Year')) {
            return {
                open: false,
                property
            };
        }
    });
</script>

<div class="flex-grow flex-col text-grey">
    <div class="lg:max-h-[34rem] gap-7 lg:gap-x-10 lg:gap-y-16 flex flex-col flex-wrap justify-between">
        {#each categories as category}
            {#if category}
                <div class="flex flex-col gap-0 lg:gap-4">
                    <button
                        on:click={() => {
                            category.open = !category.open;
                        }}
                        class="text-[16px] text-left text-primary tracking-widest font-medium uppercase flex justify-between items-center cursor-auto"
                    >
                        {category.property.translations[isoCode]}
                        <span
                            class="block lg:hidden transition-transform duration-200 transform {category.open
                                ? 'rotate-180'
                                : ''}"
                        >
                            <AccordionIcon />
                        </span>
                    </button>
                    {#if category.open || !$isMobile}
                        <div
                            transition:slide={{}}
                            class="grid grid-cols-2 lg:flex h-fit flex-col mt-6 lg:mt-3 lg:border-l gap-5 border-neutral-500 px-4"
                        >
                            {#each Object.entries(category.property.options)
                                .filter((option) => option[1]['en-GB'] !== 'unknown')
                                .slice(0, 5) as item}
                                <a
                                    on:click={() => (dropdownActive = false)}
                                    href="/{lang}/search?filter={buildFilterURL({
                                        [category.property.translations['en-GB'].toLowerCase() + '.id']: [item[0]]
                                    })}"
                                    class="hover:text-offwhite transition-colors duration-300 text-base"
                                    >{item[1][isoCode]}</a
                                >
                            {/each}
                            {#if Object.entries(category.property.options).length > 5}
                                <a
                                    on:click={() => (dropdownActive = false)}
                                    class="hover:text-offwhite uppercase font-medium text-sm duration-300 transition-colors text-secondary"
                                    href="/{lang}/search">{$t('shop.search.more')}</a
                                >
                            {/if}
                        </div>
                    {/if}
                    <div class="block lg:hidden h-[1px] bg-neutral-700 mt-6" />
                </div>
            {/if}
        {/each}
    </div>
</div>
